<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const clicked = (e) => {
  emit("click", e);
};

const buttonClass = computed(() => {
  if (props.active) {
    return "ecv-call-button active";
  }
  return "ecv-call-button";
});
</script>

<template>
  <button :disabled="disabled" :class="buttonClass" @click="clicked" :style="{ opacity: disabled ? 0.5 : 1 }">
    <v-icon :icon="props.icon" aria-hidden="true" />
  </button>
</template>

<style>
.ecv-call-button {
  transition: background-color 0.2s;
  background: #6d6d6dba;
  border: none;
  color: white;
  font-size: 1.1rem;
  padding: 0.5rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  -webkit-box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.35);
}

.ecv-call-button:hover {
  background: #8d8d8dba;
}

.ecv-call-button.active {
  background: #656bb5ad;
}
</style>
